var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-table',{ref:`${_vm.model}List`,attrs:{"model":_vm.model,"endpoint":_vm.endpoint,"route-params":{ id: _vm.$route.params.id, subId: { key: 'uuid' } },"route-context":"settings.businessunit.acl"},on:{"action":_vm.doAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }